/* global axios */
import ApiClient from './ApiClient';

class BroadcastsAPI extends ApiClient {
  constructor() {
    super('broadcasts', { accountScoped: true });
  }

  trigger(id) {
    return axios.post(`${this.url}/${id}/trigger`);
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  preview(id, vars = {}) {
    return axios.post(`${this.url}/${id}/preview`, { vars });
  }

  recipients(id) {
    return axios.get(`${this.url}/${id}/recipients`);
  }

  report(id) {
    return axios.get(`${this.url}/${id}/report`);
  }

  importCsv(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/import_csv`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  // Sobe a midia e devolve { file_url, blob_id }. O blob_id vai no broadcast.attachment.
  uploadMedia(file) {
    const formData = new FormData();
    formData.append('attachment', file);
    return axios.post(`${this.baseUrl()}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new BroadcastsAPI();
